import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot, UrlTree } from '@angular/router';

import { PageService } from '~shared/services/page.service';
import { AuthorizationIdamStateService } from '~app/modules/authorization/services/authorization-idam-state.service';
import { AuthorizationStateType } from '~app/modules/authorization/constants/authorization.constant';
import { AuthService } from '~app/modules/authorization/services/authorization-idam.service';
import { isPlatformServer } from '@angular/common';
import { ServerLoggerService } from '~shared/modules/server-logger/services/server-logger.service';
import { CheckoutCommonUtil } from '~app/modules/checkout/utils/checkout-common-util';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly pageService: PageService,
    private readonly authorizationIdamStateService: AuthorizationIdamStateService,
    private readonly authService: AuthService,
    @Inject(PLATFORM_ID) private platform: Object,
    private serverLogger: ServerLoggerService
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const orderNumber = CheckoutCommonUtil.getTmpOrderNumberFromLocalStorage();
    if (isPlatformServer(this.platform)) {
      return of(true);
    }

    const isReviewPage = state.url.includes('/review');

    if (isReviewPage) {
      this.serverLogger.info(`Checkout - FE - ${orderNumber} AuthGuard - started`);
    }

    return this.authorizationIdamStateService.state$.pipe(
      filter(({ type }) => type !== AuthorizationStateType.Pending),
      map(({ type }) => {
        if (isReviewPage) {
          this.serverLogger.info(`Checkout - FE - ${orderNumber} AuthGuard - not pending`, {
            type,
          });
        }

        if (type === AuthorizationStateType.LoggedIn) {
          return true;
        } else {
          if (isReviewPage) {
            this.serverLogger.info(`Checkout - FE - ${orderNumber} AuthGuard -  redirect to login`);
          }

          this.authService.login(state.url.split('?')[0]);
          return false;
        }
      })
    );
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
